// eslint-disable-next-line
import {
  UserLayout,
  UserLayout2,
  AgreementLayout,
  StudyLayout,
  // BasicLayout,
  // RouteView,
  BlankLayout,
  // PageView
  BaseLayout,
  CalendarLayout
} from '@/layouts'
// import { bxAnaalyse } from '@/core/icons'

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BlankLayout,
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/watchLive/Index',
        name: 'watchIndex',
        component: () => import('@/views/watchLive/Index'),
        meta: {
          title: '课次学习',
          icon: 'robot',
          permission: ['table']
        },
      },
      {
        path: '/watchLiveV2/Index',
        name: 'watchV2Index',
        component: () => import('@/views/watchLiveV2/Index'),
        meta: {
          title: '课次学习',
          icon: 'robot',
          permission: ['table']
        },
      },
      {
        path: '/watchLiveBjy/Index',
        name: 'watchLiveBjy',
        component: () => import('@/views/watchLiveBjy/Index'),
        meta: {
          title: '课次学习',
          icon: 'robot',
          permission: ['table']
        },
      },
      {
        path: '/playbackBjy/Index',
        name: 'playbackBjy',
        component: () => import('@/views/playbackBjy/Index'),
        meta: {
          title: '课次学习',
          icon: 'robot',
          permission: ['table'],
          keepAlive: false
        },
      },
      {
        path: '/videoBjy/Index',
        name: 'videoBjy',
        component: () => import('@/views/videoBjy/Index'),
        meta: {
          title: '课次学习',
          icon: 'robot',
          permission: ['table']
        },
      },
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

// function dynamicPropsFn (route) {
//   console.log('route', route)
//   // const now = new Date()
//   return {
//     // name: (now.getFullYear() + parseInt(route.params.years)) + '!'
//     meta: route.meta,
//     query: route.query,
//     params: route.query
//   }
// }

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  // 编辑
  // {
  //   path: '/:sitesPath/edit/:id',
  //   component: () => import('@/views/sitesEditor/edit/Index'),
  //   meta: {
  //     title: '站点编辑',
  //     keepAlive: false
  //   },
  //   props: true
  // },
  // {
  //   path: '/:sitesPath/edit/menu',
  //   component: () => import('@/views/sitesEditor/edit/Index'),
  //   meta: {
  //     title: '站点编辑',
  //     keepAlive: false
  //   },
  //   props: true
  // },
  // {
  //   path: '/articleEditor/edit/:id',
  //   component: () => import('@/views/articleEditor/edit/Index'),
  //   meta: {
  //     title: '文章编辑',
  //     keepAlive: false
  //   }
  // },
  {
    path: '/mock',
    name: 'mock',
    component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/mock')
  },
  {
    path: '/sxgcAcc',
    name: 'sxgcAcc',
    component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/cost-acc/sxgc-acc')
  },
  {
    path: '/costAcc',
    name: 'costAcc',
    component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/cost-acc/sxgc-acc')
  },

  {
    path: '/myAddition',
    name: 'myAddition',
    component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/myAddition')
  },
  {
    path: '/',
    component: BaseLayout,
    redirect: '/study/course',
    hidden: true,
    children: [
      {
        path: 'user',
        component: UserLayout,
        children: [
          {
            path: 'login',
            name: 'login',
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/Login')
          },
          {
            path: 'register',
            name: 'register',
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/Register')
          },
          // {
          //   path: 'empty',
          //   name: 'empty',
          //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/empty')
          // },
          // {
          //   path: 'register-result',
          //   name: 'registerResult',
          //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/RegisterResult')
          // },
          // {
          //   path: 'recover',
          //   name: 'recover',
          //   component: undefined
          // }
        ]
      },
      {
        path: 'user',
        component: UserLayout2,
        children: [
          {
            path: 'retrieve',
            name: 'retrieve',
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/Retrieve')
          },
          // {
          //   path: 'empty',
          //   name: 'empty',
          //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/empty')
          // }
        ]
      },
      {
        path: 'user',
        component: CalendarLayout,
        children: [
          {
            path: 'empty',
            name: 'empty',
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/empty')
          }
        ]
      },
      {
        path: 'homeWork',
        name: 'homeWork',
        meta: { title: '作业' },
        component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/myClassDetail/homeWork'),
      },
      {
        path: 'images',
        name: 'images',
        meta: { title: '资料查看' },
        component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/myClassDetail/components/images.vue'),
      },
      // {
      //   path: '/empty',
      //   redirect: '/empty',
      //   name: 'empty',
      //   component: () => import(/* webpackChunkName: "fail" */ '@/views/system/user/empty')
      // },
      // {
      //   path: 'gradeDetail',
      //   name: 'gradeDetail',
      //   meta: { title: '班级详情' },
      //   component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/gradeDetail'),
      // },
      // {
      //   path: 'myClassDetail',
      //   name: 'myClassDetail',
      //   meta: { title: '课程详情' },
      //   component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/myClassDetail')
      // },
      {
        path: 'agreement',
        component: AgreementLayout,
        children: [
          {
            path: 'about',
            name: 'about',
            meta: { title: '关于我们' },
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/agreement/About')
          },
          {
            path: 'user',
            name: 'user',
            meta: { title: '用户协议' },
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/agreement/User')
          },
          {
            path: 'privacy',
            name: 'privacy',
            meta: { title: '隐私条款' },
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/agreement/Privacy')
          },
          {
            path: 'law',
            name: 'law',
            meta: { title: '法律声明' },
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/agreement/Law')
          },
          {
            path: 'contact',
            name: 'contact',
            meta: { title: '联系我们' },
            component: () => import(/* webpackChunkName: "user" */ '@/views/system/agreement/Contact')
          }
        ]
      },
      {
        path: 'study',
        name: 'study',
        component: StudyLayout, // 课程中心
        redirect: '/study/course',
        meta: { title: '学习中心' },
        children: [
          {
            path: 'course',
            name: 'course',
            meta: { title: '我的课程' },
            // component: { render(c) { return c('router-view') } },
            // redirect: 'study/course/gradeDetail',
            component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/Course.vue'),
            children: [
              // {
              //   path: 'gradeDetail',
              //   name: 'gradeDetail',
              //   meta: { title: '班级详情' },
              //   component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/gradeDetail'),
              // },
              // {
              //   path: 'myClassDetail',
              //   name: 'myClassDetail',
              //   meta: { title: '课程详情' },
              //   component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/myClassDetail'),
              // },
              {
                path: 'expireCourse',
                name: 'expireCourse',
                meta: { title: '过期课程' },
                component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/expireCourse/expireCourse.vue')
              },
            ]
          },
          {
            path: 'noApplyCourse',
            name: 'noApplyCourse',
            meta: { title: '我的课程' },
            component: () => import('@/views/LearningCenter/myCourse/myCourseNoApply.vue')
          },
          {
            path: 'liveCalendar',
            name: 'liveCalendar',
            meta: { title: '直播日历' },
            component: () => import('@/views/calendar/live')
          },
          {
            path: 'qa',
            name: 'qa',
            meta: { title: '我的问答' },
            component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/QA/qa'),
          },
          {
            path: 'activate',
            name: 'activate',
            meta: { title: '课程码激活' },
            component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/Activate')
          },
          {
            path: 'account',
            name: 'account',
            meta: { title: '账号管理' },
            component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/Account')
          },
          {
            path: 'qadetails',
            name: 'qadetails',
            meta: { title: '问答详情' },
            component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/QaDetails')
          },
          {
            path: 'gradeDetail',
            name: 'gradeDetail',
            component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/gradeDetail'),
            // props: dynamicPropsFn,
            // props: { name: '123' },
            props: route => ({ title: route.meta.title }),
            children: [
              {
                path: 'myClassDetail',
                name: 'myClassDetail',
                meta: { title: '课程目录' },
                component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/myClassDetail'),
                // beforeEnter: (to, from, next) => {
                //   if (!Object.keys(to.query).length) {
                //     if (!from.name) {
                //       next({ name: 'study', replace: true })
                //     }
                //     next(false)
                //   } else {
                //     next()
                //   }
                // }
              },
            ]
          },
          // {
          //   path: 'myClassDetail',
          //   name: 'myClassDetail',
          //   meta: { title: '课程目录' },
          //   component: () => import(/* webpackChunkName: "study" */ '@/views/LearningCenter/course/myClassDetail'),
          // },
        ]
      },
      {
        path: 'myStudyPlan',
        component: StudyLayout, // 学习计划
        // redirect: '/study/course',
        children: [
          {
            path: 'myStudyPlan',
            name: 'myStudyPlan',
            // component: () => import(/* webpackChunkName: "study" */ '@/views/...')
          },
          {
            path: 'myStudyPlanDetail',
            name: 'myStudyPlanDetail',
            // component: () => import(/* webpackChunkName: "study" */ '@/views/...')
          },
        ]
      },
      {
          path: '/calendar',
          component: CalendarLayout,
          redirect: '/calendar/live',
          children: [
            //
            //   path: 'live',
            //   name: 'liveCalendar',
            //   component: () => import('@/views/calendar/live')
            // },

            {
              path: 'conversation',
              name: 'conversation',
              component: () => import('@/views/LearningCenter/conversation/index.vue')
            }

          ]
      },

      {
        path: '/user/explain',
        name: 'explain',
        component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/Explain')
      },
      {
        path: '/user/forgotPwd',
        name: 'forgotPwd',
        component: () => import(/* webpackChunkName: "forgotPwd" */ '@/views/system/forgotPwd')
      },
      {
        path: '/user/wechatLogin',
        name: 'wechatLogin',
        component: () => import(/* webpackChunkName: "wechatLogin" */ '@/views/system/user/components/scanWechat')
      },
      {
        path: '/user/statement',
        name: 'statement',
        component: () => import(/* webpackChunkName: "wechatLogin" */ '@/views/system/user/statement')
      },
      // {
      //   path: '/user/empty',
      //   name: 'empty',
      //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/empty')
      // }
      // {
      //   path: 'login',
      //   name: 'login',
      //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/Login')
      // },
      // {
      //   path: 'register',
      //   name: 'register',
      //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/Register')
      // },
      // {
      //   path: 'register-result',
      //   name: 'registerResult',
      //   component: () => import(/* webpackChunkName: "user" */ '@/views/system/user/RegisterResult')
      // },
      // {
      //   path: 'recover',
      //   name: 'recover',
      //   component: undefined
      // }
    ]
  },

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [
      {
        path: 'home',
        name: 'TestHome',
        component: () => import('@/views/Home')
      }
    ]
  },
  // {
  //   path: '/empty',
  //   redirect: '/user/empty',
  //   name: 'empty',
  //   component: () => import(/* webpackChunkName: "fail" */ '@/views/system/user/empty')
  // },
  {
    path: '/404',
    redirect: '/user/login',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/system/user/Login')
  }
]
